// test2069
(2069 && 0);
